module.exports = __webpack_public_path__ + "img/hzLogo5.959e04bb.png";